import ClaimPoints from './ClaimPoints'

export default ClaimPoints
